import { TemplateData, TemplateParams } from '.';

const pathDeadlineExpired = ({
  defaultPlaceholders,
  messages,
  serverConfig
}: TemplateParams): TemplateData => ({
  category: 'paths',
  email: {
    buttonEnabled: true,
    buttonLink: '{{pathUrl}}',
    buttonText: messages.authSignIn,
    content: `
      <p>
        ${messages.pathDeadlineExpired}
        ${messages.pathDeadlineAccess}
      </p>`,
    contentAfterButton: `
      <p>
        ${messages.emailSignatureText}
      </p>`,
    footnote: `${messages.emailContentClarification} {{contactEmail}}`,
    heading: messages.emailGreeting,
    subject: `{{siteName}}: ${messages.pathStepDeadlineSubjectExpired}`
  },
  placeholders: {
    pathTitle: {
      label: messages.pathsPathTitle,
      example: 'Test path'
    },
    pathUrl: {
      label: messages.pathsPathLink,
      example: `${serverConfig.adminUrl}/paths/1`
    },
    stepNumber: {
      label: messages.pathsStepNumber,
      example: '1'
    },
    ...defaultPlaceholders
  },
  title: messages.emailTypePathDeadlineExpired
});

export default pathDeadlineExpired;
